<template>
  <div class="m-wrap" v-if="isOpen">
    <div class="m-mask"></div>
    <div class="m-container">
      <div class="m-container_header jtf_between" v-if="title || !hiddenCloseBtn">
        <div class="m_title">{{ title }}</div>
        <div class="m_icon-close click" v-if="!hiddenCloseBtn">
          <img
            @click="close"
            height="18"
            src="@/assets/images/x.svg"
            alt="x"
            width="18"
          />
        </div>
      </div>
      <div class="m-container_body">
        <slot></slot>
      </div>
      <div class="m-container_footer">
        <!---dung btnClass vi btn css khong an, do su dung mixin-->
        <div v-if="isBtnGroup" class="r-btn_group jtf_between">
          <slot name="btn_group" :click="onIconClick"/>
        </div>
        <router-link v-else-if="directLink" :to="directLink">
          <button
            class="click"
            :class="btnClass ? btnClass : 'btn'"
            type="button"
            @click="close"
          >
            {{ btnName }}
          </button>
        </router-link>
        <button
          v-else
          class="click"
          :class="btnClass ? btnClass : 'btn'"
          type="button"
          @click="close"
        >
          {{ btnName }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CusModal',
  props: {
    title: {
      type: String,
    },
    btnName: {
      type: String,
    },
    btnClass: {
      type: String,
    },
    isBtnGroup: {
      type: Boolean,
      default: false,
    },
    directLink: {
      type: String,
      default: '',
    },
    noClickOutSide: {
      type: Boolean,
      default: false,
    },
    hiddenCloseBtn: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters('sub-account', ['disable']),
  },
  methods: {
    open() {
      this.isOpen = true;
      document.body.classList.add('no-scroll');
      // document.documentElement.style.overflow = 'hidden';
    },
    close() {
      document.body.classList.remove('no-scroll');
      // document.documentElement.style.overflow = 'auto';
      this.isOpen = false;
    },
    onIconClick() {
    },
  },
  beforeUnmount() {
    document.body.classList.remove('no-scroll');
  }
};
</script>
